/*
 * @Author: Took
 * @Date: 2019-09-05 19:38:40
 * @LastEditors: Took
 * @LastEditTime: 2019-09-05 19:38:40
 * @Description: file content
 */
import Vue from 'vue'

import '../../../theme/index.css'
import './el-message.scss'
import './el-message-box.scss'

import {
  Button,
  Container,
  Header,
  Aside,
  Main,
  Footer,
  Menu,
  Submenu,
  MenuItem,
  MenuItemGroup,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Card,
  Form,
  FormItem,
  Input,
  Table,
  TableColumn,
  Pagination,
  Dialog,
  Tree,
  CheckboxGroup,
  Checkbox,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  Switch,
  Slider,
  Select,
  Option,
  OptionGroup,
  Popover,
  DatePicker,
  TimePicker,
  MessageBox,
  Loading,
  Radio,
  RadioGroup,
  RadioButton,
  TimeSelect,
  Message,
  Tooltip,
  Badge,
  Avatar,
  Divider,
  Tabs,
  TabPane,
  Upload,
  Drawer,
  Tag,
  ColorPicker,
  InfiniteScroll,
  Image,
  Timeline,
  TimelineItem,
  Cascader,
  Autocomplete,
  InputNumber,
  Transfer,
  Progress,
  Steps,
  Step,
  Carousel,
  CarouselItem
} from 'element-ui'

Vue.use(Button)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Main)
Vue.use(Footer)
Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Row)
Vue.use(Col)
Vue.use(Card)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Input)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(Pagination)
Vue.use(Dialog)
Vue.use(Tree)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(Dropdown)
Vue.use(DropdownItem)
Vue.use(DropdownMenu)
Vue.use(Popover)
Vue.use(Switch)
Vue.use(Select)
Vue.use(Slider)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(DatePicker)
Vue.use(TimePicker)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(TimeSelect)
Vue.use(Tooltip)
Vue.use(Badge)
Vue.use(Avatar)
Vue.use(Divider)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Upload)
Vue.use(Drawer)
Vue.use(Tag)
Vue.use(ColorPicker)
Vue.use(InfiniteScroll)
Vue.use(Image)
Vue.use(Timeline)
Vue.use(TimelineItem)
Vue.use(Cascader)
Vue.use(Autocomplete)
Vue.use(InputNumber)
Vue.use(Transfer)
Vue.use(Progress)
Vue.use(Steps)
Vue.use(Step)
Vue.use(Carousel)
Vue.use(CarouselItem)

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$message = Message
